import React, { useEffect } from "react";
import UserMasterLayout from "../../layouts/UserMasterLayout";
import { PageTitle } from "../../components/admin";
import { USER_MASTER_EXPORT } from "../../constants/routes";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { setPageSettings } from "../../store/actions/pageActions";
import FileExport from "../../components/file-management/FileExport";
import { API_USER_MASTER_EXPORT_ACTIVE_USER, API_USER_MASTER_EXPORT_ALL_USER } from "../../constants/api";
import {ButtonExport, RedirectAlert} from "../../components";
import {getUserExportPageSettings} from "../../api/setting/userMasterPageApi";
import {
  clearPageLoading
} from "../../store/actions";
import {USER_MASTER_EXPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function UserExportPage() {
  useRedirectPage(USER_MASTER_EXPORT_PAGE);
  useDocumentTitle("ユーザーマスタエクスポート - ユーザーマスタ");
  const breadcrumb = getPageBreadcrumb(USER_MASTER_EXPORT);
  const dispatch = useDispatch();

  useEffect(() => {
    const response = getUserExportPageSettings();
    dispatch(setPageSettings(response.data));
    dispatch(clearPageLoading());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserMasterLayout breadcrumb={breadcrumb}>
      <PageTitle title="ユーザーマスタエクスポート" />
      <RedirectAlert />
      <FileExport
        title="現在のユーザーマスタの状態をファイル出力します"
        description="ユーザーデータをExcelファイルとしてエクスポートするために、以下のボタンを押してください。"
      >
        <div className="flex items-center 2xl:space-x-[80px] xl:space-x-[60px] lg:space-x-[40px] md:space-x-[20px]">
          <ButtonExport
            buttonColor="yellow"
            iconColor="616161"
            description="無効化したユーザーを含む"
            borderColor="tenken__border-gray-500"
            descriptionTextColor="text-tenken-gray-900 xl:text-base text-[14px]"
            titleTextColor="text-tenken-gray-700 xl:text-[22px] lg:text-[18px] text-[16px]"
            apiUrl={API_USER_MASTER_EXPORT_ALL_USER}
            id="button__export-all-users"
          />
          <ButtonExport
            buttonColor="primary"
            iconColor="616161"
            description="無効化したユーザーを含まない"
            borderColor="tenken__border-gray-500"
            descriptionTextColor="text-white xl:text-base md:text-[14px]"
            titleTextColor="text-white xl:text-[22px] lg:text-[18px] text-[16px]"
            apiUrl={API_USER_MASTER_EXPORT_ACTIVE_USER}
            id="button__export-users-active"
          />
        </div>
      </FileExport>
    </UserMasterLayout>
  );
}
